import React from 'react'
import { useGalaxyStore } from '../../core/state/GalaxyStore'
import { NetworkStats } from './NetworkStats/NetworkStats'
import { ObjectInspector } from './ObjectInspector/ObjectInspector'
import { CameraControls } from './CameraControls/CameraControls'
import { SceneManager } from '../../visualization/scene/GalaxyScene'
import './HUD.css'

export interface HUDProps {
  className?: string
  scene?: SceneManager | null
}

export const HUDContainer: React.FC<HUDProps> = ({ className, scene }) => {
  const uiSettings = useGalaxyStore(state => state.ui?.settings)
  const selectedObject = useGalaxyStore(state => state.ui.selectedObject)

  return (
    <div className={`hud-container ${className || ''}`} 
         style={{ opacity: uiSettings?.hudOpacity || 1 }}>
      
      {/* Top Left Panel - Network Stats */}
      <div className="hud-top">
        <div className="hud-panel">
          <NetworkStats className="network-stats-compact" mode="compact" />
        </div>
      </div>

      {/* Right Panel - Object Inspector (only when object selected) */}
      {selectedObject && (
        <div className="hud-center-right">
          <div className="hud-panel">
            <ObjectInspector />
          </div>
        </div>
      )}

      {/* Bottom Panel - Camera Controls */}
      <div className="hud-bottom">
        <div className="hud-panel">
          <CameraControls scene={scene} />
        </div>
      </div>
    </div>
  )
}